/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DivideIcon20Light = forwardRef('DivideIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 6a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
        React.createElement("path", { d: "M3 9.5a.5.5 0 0 1 .5-.5h13.083a.5.5 0 1 1 0 1H3.5a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M11 14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" })));
});
